import { useContext } from 'react';
import { Route, Switch, useLocation, useHistory } from 'react-router-dom';
import { Navbar, NavbarBrand, Button } from 'reactstrap';
import { AuthContext } from '../../context/auth';
import { CampaignContext } from '../../context/campaign';
import { Footer } from '../../shared/components/Footer';
import { AccountSetup } from './AccountSetup';
import { CreatePassword } from './CreatePassword';
import { CreatePasswordConfirmation } from './CreatePasswordConfirmation';
import { Who } from './Who';
import { CampaignType } from './Condition/CampaignType';
import { When } from './Condition/When';
import { MedicalProfessional } from './Condition/MedicalProfessional';
import { Cost } from './Financials/Cost';
import { Contribution } from './Financials/Contribution';
import { Insurance } from './Financials/Insurance';
import { Community } from './Community';
import { TermsOfService } from './Agreements/TermsOfService';
import { Agreements } from './Agreements/Agreements';
import { PatientName } from './PatientName';
import { PatientDetails } from './PatientDetails';
import { Continue } from './Agreements/Continue';
import { Other } from './Agreements/Other';
import { ContactPreference } from './ContactPreference';
import { CreatePasswordLegacy } from './CreatePasswordLegacy';

export const GetStartedIndex = () => {
  const [{}, userDispatch] = useContext(AuthContext);
  const [{}, campaignDispatch] = useContext(CampaignContext);
  const location = useLocation();
  const history = useHistory();

  const hideSaveProgressPaths = [
    '/get-started/account-setup',
    '/get-started/create-password',
    '/get-started/create-password/confirmation',
    '/get-started/who',
  ];

  const showProgressSave = !hideSaveProgressPaths.includes(location.pathname);

  const logout = async () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    userDispatch({
      type: 'set_user',
      user: null,
    });
    campaignDispatch({
      type: 'set_campaign',
      payload: null,
    });
    history.push('/login');
  };

  return (
    <div>
      <Navbar
        container
        color='white'
        className='border-bottom border-primary border-2'
      >
        <NavbarBrand href='/login'>
          <div
            className='sidebar__logo'
            style={{ width: '169px', height: '64px' }}
          />
        </NavbarBrand>
        {showProgressSave && (
          <Button color='primary' size='sm' onClick={logout}>
            Save and Return Later
          </Button>
        )}
      </Navbar>
      <Switch>
        <Route path='/get-started/account-setup' component={AccountSetup} />
        {/* Use VITE_USE_LEGACY_PASSWORD=false to use the new CreatePassword component, defaults to legacy */}
        <Route
          exact
          path='/get-started/create-password'
          component={
            import.meta.env.VITE_USE_LEGACY_PASSWORD === 'false'
              ? CreatePassword
              : CreatePasswordLegacy
          }
        />
        <Route
          path='/get-started/create-password/confirmation'
          component={CreatePasswordConfirmation}
        />
        <Route path='/get-started/who' component={Who} />
        <Route path='/get-started/other/terms' component={Other} />
        <Route path='/get-started/condition/type' component={CampaignType} />
        <Route path='/get-started/condition/when' component={When} />
        <Route
          path='/get-started/condition/medical-professional'
          component={MedicalProfessional}
        />
        <Route path='/get-started/financials/cost' component={Cost} />
        <Route
          path='/get-started/financials/contribution'
          component={Contribution}
        />
        <Route path='/get-started/financials/insurance' component={Insurance} />
        <Route path='/get-started/community' component={Community} />
        <Route
          path='/get-started/terms-of-service'
          component={TermsOfService}
        />
        <Route path='/get-started/agreements' component={Agreements} />
        <Route path='/get-started/continue' component={Continue} />
        <Route
          path='/get-started/contact-preference'
          component={ContactPreference}
        />

        <Route path='/get-started/patient/who' component={PatientName} />
        <Route path='/get-started/patient/details' component={PatientDetails} />
      </Switch>
      <Footer />
    </div>
  );
};
